import ozLeadPhone from './oz-lead-phone.vue'

export default ozLeadPhone
